import React from 'react';
import AppSelect from '../AppSelect';
import AppRangePicker from '../AppRangePicker';
import { Col, Drawer, Flex, Form, Row, Space } from 'antd';
import AppSearch from '../AppSearch';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

function AppTableControl({
  selectOptions,
  selectValue,
  defaultSelectValue,
  selectLabel = 'Package',
  setSelectValue,
  setPageIndex,
  hasSelect = true,
  hasDatePicker = true,
  selectPlaceholder,
  date,
  setDate,
  dateLimit,
  selectRef,
  noStyle = false,
  searchPhone,
  setSearchPhone,
  hasPhone,
  open,
  setOpen,
}) {
  const isBreak = useMediaQuery(`(max-width: 1280px) and (min-width: 992px)`);
  const isMobilePlus = useMediaQuery(`(max-width: ${mediaQueryPoints.mdPlus}px)`);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  const handleOnOk = (dates, formatted) => {
    setDate?.(formatted);
    if (setPageIndex) {
      setPageIndex(1);
    }
  };

  const handleCloseDrawer = () => {
    setOpen(false);
  };

  // if (isMobile) {
  //   return (
  //     <Drawer open={open} className="custom-drawer" onClose={handleCloseDrawer}>
  //       <Form layout="vertical" className="w-full">
  //         <Row className="w-full">
  //           <Col span={24}>
  //             {hasSelect && (
  //               <AppSelect
  //                 label={selectLabel}
  //                 ref={selectRef}
  //                 items={selectOptions}
  //                 onChange={(v) => setSelectValue(v)}
  //                 value={selectValue}
  //                 defaultValue={defaultSelectValue}
  //                 placeholder={selectPlaceholder || `Select ${selectLabel}`}
  //               />
  //             )}
  //           </Col>
  //         </Row>
  //         <Row className="w-full">
  //           <Col span={24}>
  //             {hasDatePicker && (
  //               <AppRangePicker date={date} onOk={handleOnOk} isMax1Year={isMax1Year} />
  //             )}
  //           </Col>
  //         </Row>
  //         <Row>
  //           <Col span={24}>
  //             {hasPhone && (
  //               <AppSearch
  //                 placeholder={'Phone number'}
  //                 value={searchPhone}
  //                 onChange={(val) => {
  //                   setSearchPhone(val);
  //                 }}
  //                 label="Phone number"
  //               />
  //             )}
  //           </Col>
  //         </Row>
  //       </Form>
  //     </Drawer>
  //   );
  // }

  const renderColSpans = () => {
    if (isMobile) {
      return [24, 24, 24];
    } else {
      return [6, 8, 6];
    }
  };

  return (
    <Form layout="vertical" className="w-full">
      <Row
        gutter={8}
        className={`${!noStyle ? 'bg-white p-4 pt-2 rounded-md' : 'pt-2'} w-full ${isMobilePlus ? 'max-w-full' : 'max-w-[80%]'}`}
      >
        {hasSelect && (
          <Col span={renderColSpans()[0]}>
            <AppSelect
              label={selectLabel}
              ref={selectRef}
              items={selectOptions}
              onChange={(v) => setSelectValue(v)}
              value={selectValue}
              defaultValue={defaultSelectValue}
              placeholder={selectPlaceholder || `Select ${selectLabel}`}
              formItemClassName="mb-2"
            />
          </Col>
        )}
        {hasDatePicker && (
          <Col span={renderColSpans()[1]}>
            <AppRangePicker
              date={date}
              onOk={handleOnOk}
              dateLimit={dateLimit}
              formItemClassName="mb-2"
            />
          </Col>
        )}
        {hasPhone && (
          <Col span={renderColSpans()[2]}>
            <AppSearch
              placeholder={'Phone number'}
              value={searchPhone}
              onChange={(val) => {
                setSearchPhone(val);
              }}
              label="Phone number"
              formItemClassName="mb-2"
            />
          </Col>
        )}
      </Row>
    </Form>
  );
}

export default AppTableControl;
